import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputTextarea } from "primereact/inputtextarea";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { baseUrl, Fetch } from "../../../shared/Fetch";
import { JVDropdown } from "../../../shared/JVDropdown";
import { JVInput } from "../../../shared/JVInput";
import { ITenderMast } from "./Tender_Mast";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { ILogin } from "../../../models/Login";
import WorkStreamDocument from "../workStreamList/WorkStreamDocument";
import { JVDate } from "../../../shared/JVDate";
import { IWorkStream } from "../workStreamList/WorkStreamList";
import { Tooltip } from "primereact/tooltip";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { Toast } from "primereact/toast";

interface Props {
  open: boolean;
  singleData: ITenderMast;
  toast: any;
  onHide: () => void;
  reloadTable: () => void;
}

interface ITenderWorkStream {
  id?: number;
  tender_ID: number;
  workstream_Category_ID: number;
  title: string;
  description: string;
  assigned_To: number;
  assigned_To_ID: number;
  assigned_By: string;
  assigned_At: Date | null;
  deadline_Date?: Date | null;
  status?: string;
  workstream_Type?: number | null;
  Ref_Doc_Path?: string;
}

const schema = yup.object({
  workstream_Category_ID: yup.number().moreThan(0, "Work Stream Category is required").required(),
  title: yup.string().trim().required("Title is required"),
  assigned_To: yup.number().moreThan(0, "Assigned User is required").required(),
  // workstream_Type: yup.number().moreThan(0, "Workstream Type is required").required(),
});

const TenderWorkStream = ({ open, singleData, toast, onHide, reloadTable }: Props) => {
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState<any[]>([]);
  const [tableData, setTableData] = useState<any[]>([]);
  const [propsTableData, setPropsTableData] = useState<any[]>([]);
  const [editId, setEditId] = useState<number>(0);
  const [description, setDescription] = useState("");
  const [openWorkSDocs, setOpenWorkSDocs] = useState({ open: false, singleData: {} } as { open: boolean; singleData: any });
  const [users, setUsers] = useState<any[]>([]);
  const [file, setFile] = useState<File | null>(null);
  const [descriptionDialog, setDescriptionDialog] = useState<{ visible: boolean; description: string }>({ visible: false, description: "" });
  const [workStreamDescription, setWorkStreamDescription] = useState<{ visible: boolean; description: string }>({ visible: false, description: "" });
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  let _roles: Array<number> = [];
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });
  const DateFormat = loginObj.date_Format;
  const toastee = useRef<any>();
  // const workstreamTypeOption = [
  //   { name: "Master", value: 1 },
  //   { name: "Client Specific", value: 2 },
  // ];
  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
    setValue,
  } = useForm<ITenderWorkStream>({
    resolver: yupResolver(schema),
    defaultValues: {
      id: 0,
      tender_ID: 0,
      workstream_Category_ID: 0,
      title: "",
      description: "",
      deadline_Date: null,
      workstream_Type: null,
    },
    shouldFocusError: false,
  });

  const fileUploadRef = useRef<FileUpload>(null);

  const loadUsers = async (categoryId: number) => {
    const response = await Fetch("TenderWorkstream/GetUsersByWorkstreamCategory", "GET", null, `workstreamCategoryId=${categoryId}`, toast);

    if (response?.ok) {
      const data = await response.json();
      setUsers(data);
    }
  };

  const selectedCategory = watch("workstream_Category_ID");
  useEffect(() => {
    //Technical-3 & Others-6
    if (selectedCategory > 0 && selectedCategory !== 3 && selectedCategory !== 6) {
      loadUsers(selectedCategory);
    } else if (selectedCategory > 0 && selectedCategory === 3) {
      setUsers([{ user_Name: loginObj.name, login_ID: loginObj.id }]);
      setValue("assigned_To", loginObj.id);
    } else if (selectedCategory > 0 && selectedCategory === 6) {
      setUsers([{ user_Name: singleData?.added_By || "", login_ID: singleData?.added_By_ID || 0 }]);
      setValue("assigned_To", singleData?.added_By_ID ?? 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory, singleData]);

  const loadCategories = async () => {
    const response = await Fetch("Tender_Mast/TenderWorkStreamCategoryDropdown", "GET", null, null, toast);
    if (response?.ok) {
      const data = await response.json();
      let newOtherCatData = {
        id: 0,
        category_Name: "",
      };

      let newList = data.filter((el: any) => {
        if (!el.category_Name.includes("Other")) return true;
        else {
          newOtherCatData = {
            id: el.id,
            category_Name: el.category_Name,
          };
          return false;
        }
      });

      setCategories([...newList, newOtherCatData]);
    }
  };

  const loadTable = async () => {
    if (!singleData.id) return;
    const response = await Fetch("Tender_Mast/GetTenderWorkStream", "GET", null, `tenderId=${singleData.id}`, toast);

    if (response?.ok) {
      const data = await response.json();
      setTableData(data);
    }
  };

  const editData = async (rowData: any) => {
    setEditId(rowData.id);
    await loadUsers(rowData.workstream_Category_ID);
    reset({
      id: rowData.id,
      tender_ID: rowData.tender_ID,
      workstream_Category_ID: rowData.workstream_Category_ID,
      title: rowData.title,
      description: rowData.description,
      assigned_To: rowData.assigned_To_ID,
      deadline_Date: rowData.deadline_Date ? new Date(rowData.deadline_Date) : null,
      workstream_Type: rowData.workstream_Type,
    });

    setDescription(rowData.description ?? "");
  };

  useEffect(() => {
    if (open) {
      loadCategories();
      loadTable();
      reset({
        id: 0,
        tender_ID: singleData.id ?? 0,
        workstream_Category_ID: 0,
        title: "",
        description: "",
        deadline_Date: null,
        workstream_Type: null,
      });
      setDescription("");
      setPropsTableData([singleData]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  // const save = async (data: ITenderWorkStream) => {
  //   try {
  //     setLoading(true);
  //     const body = { id: data.id, tender_ID: singleData.id, workstream_Category_ID: data.workstream_Category_ID, title: data.title, description: description, assigned_To: data.assigned_To, deadline_Date: data.deadline_Date, status: data.status, workstream_Type: data.workstream_Type };
  //     const response = await Fetch(editId > 0 ? `Tender_Mast/UpdateTenderWorkStream/${editId}` : "Tender_Mast/AddTenderWorkStream", editId > 0 ? "PUT" : "POST", body, null, toast);
  //     if (response?.ok) {
  //       toast.current.show({ severity: "success", summary: "Success", detail: data.id ? "Work Stream Updated Successfully" : "Work Stream Added Successfully", life: 3000 });
  //       clearForm();
  //       reloadTable();
  //       loadTable();
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const save = async (data: ITenderWorkStream) => {
    try {
      if (file !== null && data.workstream_Category_ID !== 3 && (file.size > (2 * 1024 * 1024))) {
        toast.current.show({ severity: "error", summary: "Error", detail: "File Size Can Not Be Greater than 2 MB.", life: 3000 });
        return;
      }

      setLoading(true);

      const formData = new FormData();

      formData.append("ID", String(editId));
      formData.append("Tender_ID", String(singleData.id));
      formData.append("Workstream_Category_ID", String(data.workstream_Category_ID));
      formData.append("Title", data.title);
      formData.append("Description", description);
      formData.append("Assigned_To", String(data.assigned_To));
      formData.append("Deadline_Date", data.deadline_Date ? data.deadline_Date.toISOString() : "");
      formData.append("Status", data.status ?? "");
      formData.append("Workstream_Type", String(data.workstream_Type ?? ""));

      if (file) {
        formData.append("Document", file);
      }

      const response = await fetch(`${baseUrl}${editId > 0 ? `Tender_Mast/UpdateTenderWorkStream/${editId}` : "Tender_Mast/AddTenderWorkStream"}`, {
        method: editId > 0 ? "PUT" : "POST",
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
        },
        body: formData,
      });

      if (response.ok) {
        toast.current.show({ severity: "success", summary: "Success", detail: editId > 0 ? "Work Stream Updated Successfully" : "Work Stream Added Successfully", life: 3000 });
        clearForm();
        reloadTable();
        loadTable();
      } else {
        const msg = await response.text();
        toast.current.show({ severity: "error", summary: "Error", detail: msg, life: 3000 });
      }
    } catch (err) {
      console.error(err);
      toast.current.show({ severity: "error", summary: "Error", detail: "Something went wrong.", life: 3000 });
    } finally {
      setLoading(false);
    }
  };

  const clearForm = () => {
    setEditId(0);
    reset({
      id: 0,
      tender_ID: singleData.id ?? 0,
      workstream_Category_ID: 0,
      title: "",
      description: "",
      deadline_Date: null,
      workstream_Type: null,
    });
    setDescription("");
    setFile(null);
    fileUploadRef.current?.clear();
  };

  const actionBody = (rowData: any) => {
    return (
      <>
        {(_roles.includes(55) || _roles.includes(1) || _roles.includes(56)) && rowData?.status !== "Closed" && <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" onClick={() => editData(rowData)} />}
        <Button icon="pi pi-cloud-upload" className="p-button-rounded p-button-success" onClick={() => setOpenWorkSDocs({ open: true, singleData: rowData })} tooltip="Upload Document" tooltipOptions={{ position: "top" }} />
      </>
    );
  };

  const closeDialog = () => {
    clearForm();
    onHide();
  };

  const rfpWorkstreamStatusColors: Record<string, string> = {
    Created: "#64748B",
    Assigned: "#3B82F6",
    Pending: "#F59E0B",
    Received: "#8B5CF6",
    "Under Review": "#F97316",
    "Documentation Pending": "#EAB308",
    Completed: "#22C55E",
    Rejected: "#EF4444",
    Closed: "#475569",
  };

  const statusBodyTemplate = (rowData: any) => {
    const dotColor = rfpWorkstreamStatusColors[rowData.status ?? ""] || "#64748B";

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <i
          className="pi pi-circle-fill"
          style={{
            color: dotColor,
            fontSize: "0.6rem",
          }}
        />
        <span>{rowData.status}</span>
      </div>
    );
  };

  const fileUploade = async (event: FileUploadHandlerParam) => {
    if (control._formValues.workstream_Category_ID === 3 && (event.files[0].size <= (10 * 1024 * 1024))) {
      toast.current.show({ severity: "success", content: "Document Selected." });
      const file = event.files[0];
      setFile(file);
      event.options.clear();
    } else if (control._formValues.workstream_Category_ID === 3 && (event.files[0].size > (10 * 1024 * 1024))) {
      toastee.current.show({ severity: "error", content: "Document can not be more than 10 MB.", life: 3000 });
      event.options.clear();
    } else if (event.files[0].size > 2 * 1024 * 1024) {
      toastee.current.show({ severity: "error", content: "Document can not be more than 2 MB.", life: 3000 });
      event.options.clear();
    } else {
      toast.current.show({ severity: "success", content: "Document Selected." });
      const file = event.files[0];
      setFile(file);
      event.options.clear();
    }
  };

  const downloadBody = (rowData: any) => {
    return rowData.referenceDocument ? <Button icon="pi pi-download" className="p-button-rounded p-button-success p-button-text" tooltip="Download" onClick={() => downloadDoc(rowData.id)} /> : null;
  };

  const downloadDoc = async (documentID: number) => {
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/octet-stream",
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
      },
    };
    try {
      const response = await fetch(`${baseUrl}TenderWorkstream/WorkstreamReferanceDocDownload?documentID=${documentID}`, params);

      if (response.status === 200) {
        const blob = await response.blob();

        const disposition = response.headers.get("content-disposition");
        let fileName = "WorkStream_Reference_Document";

        if (disposition) {
          const match = disposition.match(/filename="?([^"]+)"?/);
          if (match?.[1]) {
            fileName = match[1];
          }
        }

        const href = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = href;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(href);
      }
    } catch {
      toast?.current?.show({ severity: "error", summary: "Error", detail: "Something went wrong", life: 3000 });
    }
  };

  return (
    <Dialog visible={open} modal style={{ width: "75vw" }} header={`Work Stream - ${singleData.title}`} onHide={closeDialog}>
      <DataTable value={propsTableData} stripedRows showGridlines responsiveLayout="scroll" size="small" className="mt-4">
        <Column field="client_Category_Name" header="Client Category" />
        <Column field="vendor_Company_Name" header="Client Company" />
        <Column field="service_Department_Name" header="Service Department" />
        <Column field="tender_Client" header="Client POC" />
        <Column field="title" header="Title" />
        <Column field="rfP_Number" header="RFP Number" />
        <Column
          field="description"
          header="Description"
          body={(rowData: any) =>
            rowData.description ? (
              <>
                <Tooltip target=".view-description" />
                <i className="pi pi-eye view-description cursor-pointer" data-pr-tooltip="View Description" data-pr-position="top" style={{ color: "var(--primary-color)", fontSize: "1.2rem" }} onClick={() => setWorkStreamDescription({ visible: true, description: rowData.description || "" })} />
              </>
            ) : (
              "-"
            )
          }
        />
        <Column field="added_On" header="Added On" body={(rowData: any) => safeFormatDate(rowData.added_On, "dd/MM/yy", DateFormat)} style={{ maxWidth: "120px" }} />
        <Column field="tender_Published_Date" header="Published Date" body={(rowData: any) => safeFormatDate(rowData.tender_Published_Date, "dd/MM/yy", DateFormat)} style={{ maxWidth: "120px" }} />
        <Column field="due_Date" header="Due Date" body={(rowData: any) => safeFormatDate(rowData.due_Date, "dd/MM/yy", DateFormat)} style={{ maxWidth: "120px" }} />
      </DataTable>
      <hr />
      {(_roles.includes(1) || _roles.includes(26) || _roles.includes(55) || _roles.includes(56)) && (
        <form onSubmit={handleSubmit(save)} className="p-fluid formgrid grid mt-5">
          <JVDropdown required column={4} label="Work Stream Category" control={control} name="workstream_Category_ID" options={categories} optionLabel="category_Name" optionValue="id" placeholder="Select Category" error={errors.workstream_Category_ID?.message} />
          {/* <JVDropdown required column={4} label="Work Stream Type" control={control} name="workstream_Type" options={workstreamTypeOption} optionLabel="name" optionValue="value" placeholder="Select Category" error={errors.workstream_Category_ID?.message} /> */}
          <JVInput required column={4} label="Title" control={control} name="title" error={errors.title?.message} />
          <JVDropdown filter required column={4} label="Assigned User" control={control} name="assigned_To" options={users} optionLabel="user_Name" optionValue="login_ID" placeholder="Select User" disabled={selectedCategory === 17 || selectedCategory === 18} />
          <JVDate required column={4} maxDate={new Date(singleData.due_Date || "")} label="Deadline Date" control={control} name="deadline_Date" minDate={new Date()} error={errors.deadline_Date?.message} />
          <div className="field col-12 md:col-6">
            <label htmlFor="file">
              Reference Document
            </label>
            <FileUpload ref={fileUploadRef} chooseLabel="Choose Document" mode="basic" name="file" accept="*" maxFileSize={30 * 1024 * 1024} auto customUpload uploadHandler={fileUploade} />
          </div>
          <div className="field col-12">
            <label>Description</label>
            <InputTextarea value={description} rows={4} className="w-full" onChange={(e) => setDescription(e.target.value)} />
          </div>

          <div className="col-12 flex justify-content-end gap-2">
            <Button label={editId > 0 ? "Update" : "Save"} loading={loading} type="submit" />
            <Button label="Close" type="button" className="p-button-outlined" onClick={closeDialog} />
          </div>
        </form>
      )}

      <DataTable value={tableData} stripedRows showGridlines responsiveLayout="scroll" size="small" className="mt-4">
        <Column header="SN." body={(r, o) => o.rowIndex + 1} />
        <Column field="category_Name" header="Category" />
        <Column field="title" header="Title" />
        <Column
          header="Description"
          body={(rowData: IWorkStream) =>
            rowData.description ? (
              <>
                <Tooltip target=".view-description" />
                <i className="pi pi-eye view-description cursor-pointer" data-pr-tooltip="View Description" data-pr-position="top" style={{ color: "var(--primary-color)", fontSize: "1.2rem" }} onClick={() => setDescriptionDialog({ visible: true, description: rowData.description || "" })} />
              </>
            ) : (
              "-"
            )
          }
        />
        <Column header="Reference Document" body={downloadBody} />
        <Column field="status" header="Status" body={statusBodyTemplate} />
        {/* <Column field="workstream_Type_Name" header="WorkStream Type" /> */}
        <Column field="assigned_To" header="Assigned To" />
        <Column field="assigned_By" header="Assigned By" />
        <Column field="deadline_Date" header="Deadline Date" body={(rowData: any) => safeFormatDate(rowData.deadline_Date, "dd/MM/yy", DateFormat)} style={{ maxWidth: "120px" }} />
        <Column field="assigned_At" header="Assigned At" body={(rowData: any) => safeFormatDate(rowData.added_On, "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} />
        <Column field="deadline_Date" header="Deadline Date" body={(rowData: any) => safeFormatDate(rowData.deadline_Date, "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} />
        <Column header="Action" body={actionBody} style={{ width: "90px" }} />
      </DataTable>
      <WorkStreamDocument showForm={false} visible={openWorkSDocs.open} onHide={() => setOpenWorkSDocs({ open: false, singleData: {} })} workStream={openWorkSDocs.singleData} toast={toast} />
      {/* WorkStream Description Dialog */}
      <Dialog header="Description" visible={descriptionDialog.visible} modal style={{ width: "40vw" }} onHide={() => setDescriptionDialog({ visible: false, description: "" })}>
        <p style={{ whiteSpace: "pre-wrap" }}>{descriptionDialog.description}</p>
      </Dialog>
      {/* RFP Description */}
      <Dialog header="Description" visible={workStreamDescription.visible} modal style={{ width: "40vw" }} onHide={() => setWorkStreamDescription({ visible: false, description: "" })}>
        <p style={{ whiteSpace: "pre-wrap" }}>{workStreamDescription.description}</p>
      </Dialog>
      <Toast ref={toastee} />
    </Dialog>
  );
};

export default TenderWorkStream;
